import React from 'react'
import Profile from '../../Components/Doctor/Profile/Profile'

const DoctorProfilePage = () => {
  return (
    <div><Profile /></div>
  )
}

export default DoctorProfilePage